import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { SimpleModalProps } from "@models/components/modals.model";

const SimpleModal: React.FC<SimpleModalProps> = ({
  backdrop = true,
  centered = true,
  children,
  className,
  contentClassName,
  footerContent,
  isOpen,
  onClose,
  showCloseButton = true,
  size = "lg",
  title,
  zIndex,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      size={size}
      centered={centered}
      backdrop={backdrop}
      className={className}
      contentClassName={contentClassName}
      {...(zIndex ? { zIndex } : {})}
    >
      {title && (
        <ModalHeader toggle={showCloseButton ? onClose : undefined}>
          {title}
        </ModalHeader>
      )}

      <ModalBody>{children}</ModalBody>

      {footerContent && <ModalFooter>{footerContent}</ModalFooter>}
    </Modal>
  );
};

export default SimpleModal;
